























































































































import moment from 'moment';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import config from '@/config/index';
import { Component, Prop } from 'vue-property-decorator';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { actionsEvent } from '@/setup';
import { Accion } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { Funcionalidades } from '@/config/funcionalidades';
import { AgGridUtil } from '@/agGridUtil/agGridUtil';
import Confirmation from '@/components/Confirmation.vue';
import HandleErrors from '@/config/handleErrors';
import store from '@/store';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import {
  checkboxColumnDef,
  makeAccionesColumnDef,
} from '@/reusable/Grid/aggridColumnDefUtils';

import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { LoadingService } from '@/services/loadingService';
import { fetchSolicitud } from '../fetchSolicitud';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import TodasSims from './TodasSims.vue';
import { utils, writeFileXLSX } from 'xlsx';
import readXlsFile from 'read-excel-file';
@Component({
  components: {
    MantenedorGridSinCodigo,
    TodasSims,
  },
})
export default class Sims extends ComponenteBase {
  verTodasSims: boolean = false;
  filtro: string = '';
  ordesList: any[] = [];
  funcionalidad: Funcionalidades = Funcionalidades.TablaSolicitudBajaSimTarjeta;
  modalTodasSims: any;

  fileName: any = '';
  errorArchivo: boolean = true;
  errorArchivoModal: boolean = false;

  archivoB64: any = '';
  itemsDelExcel: Array<any> = [];
  errorMessage: any = '';
  esCargaDeArchivo: boolean = false;

  async postSims(): Promise<boolean> {
    let self = this;
    return fetchSolicitud(
      {
        sims: this.datosSims,
        esCargaDeArchivo: this.esCargaDeArchivo,
        idUser: JSON.parse(window.localStorage.user).id,
      },
      'solicitud_baja_sim_por_tarjeta/crear_sims'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.info('Sims cargadas con éxito', {
            timeout: 3000,
          });
          return true;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return false;
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrio un error al crear la solicitud', {
          timeout: 3000,
        });
        return false;
      });
  }

  datosSims: any;
  async guardarSims(data: any) {
    let generalNumero = data;
    this.datosSims = this.dataSelected.map((sim: any) => ({
      sbajasimnumero: generalNumero,
      simserienumero: sim.simserienumero,
      tipoubicaid: sim.tipoubicaid,
      simestado: sim.simestado,
      serienumero: sim.serienumero,
      tipoeqid: sim.tipoeqid,
      serieactivanro: sim.serieactivanro,
    }));
    let post = await this.postSims();
    return post;
  }

  async generarReporte(data: any) {
    let post = await this.postReporte(data, this.dataSelected);
    return post;
  }

  async postReporte(data: any, dataSelected: any): Promise<boolean> {
    let self = this;
    return fetchSolicitud(
      {
        sims: dataSelected,
        idcarga: data,
        idUser: JSON.parse(window.localStorage.user).id,
        clienteDefecto: JSON.parse(
          localStorage.getItem('user').replace(/'/g, '"')
        ).clienteDefecto,
      },
      'solicitud_baja_sim_por_tarjeta/crear_reporte_carga_sims'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.info(
            'Se generó el reporte ' +
              data.data.id_reporte +
              ' para procesar las sims cargadas.',
            {
              timeout: 10000,
            }
          );
          return true;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return false;
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrio un error al crear la solicitud', {
          timeout: 3000,
        });
        return false;
      });
  }

  mounted() {
    this.modalTodasSims = this.$refs.TodasSims;
  }

  /* returnUnicos(data: any) {
    let hash: any = {};
    let unicos = data.filter((seleccion: any) =>
      hash[seleccion.simserienumero]
        ? false
        : (hash[seleccion.simserienumero] = true)
    );
    return unicos;
  } */

  dataSelected: any = [];
  idsSims: any = [];
  cargarSelected(data: any) {
    this.dataSelected.push(...data);
    this.gridApi.setRowData(this.dataSelected);
    this.$emit('selected', this.dataSelected);
    this.$emit('esCargaArchivo', this.esCargaDeArchivo);
    this.gridApi.setDomLayout('autoHeight');
    this.idsSims = this.dataSelected.map((e: any) => {
      return e.simserienumero;
    });
    this.esCargaDeArchivo = false;
  }

  cargarSimTodas() {
    this.verTodasSims = true;
    //this.modalTodasSims.clearFilters();
  }

  async handleGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }
  onSelectionChanged() {}
  accionesTotales: PermisoAccion[] = [];

  // Globales
  localeText: any = config.agGridTextos;
  loadingService = new LoadingService();
  handleErrors: HandleErrors = new HandleErrors();

  // Controller
  readonly controller: string = 'funcionalidad';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  // Grilla
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  agGridUtil: AgGridUtil;
  serverSide: any = null;

  // Interfaces
  editedItem: IFuncionalidad = {};
  funcionalidades: Array<IFuncionalidad> = [];

  //vuex
  usuarioId: number = store.state.userId;

  dateFormatter(params: any) {
    return moment(params.value).format('MM/DD/YYYY');
  }
  constructor() {
    super();
  }

  readonly gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 30,
    rowModelType: 'normal',
    singleClickEdit: true,
    localeText: {
      noRowsToShow: 'No se han seleccionado sim cards',
    },
    columnDefs: [
      {
        headerName: 'SIM Número',
        field: 'simserienumero',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        sortable: true,
        minWidth: 200,
        width: 200,
        lockPinned: true,
      },
      {
        headerName: 'Serie Equipo',
        field: 'serienumero',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        sortable: true,
        minWidth: 200,
        width: 200,
      },
      {
        headerName: 'Tipo Equipo',
        field: 'tipoeqname',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        sortable: true,
        minWidth: 200,
        width: 200,
      },
      {
        headerName: 'Ubicación',
        field: 'tipoubicaname',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        sortable: true,
        minWidth: 200,
        width: 200,
      },
      {
        headerName: 'Telco',
        field: 'telconame',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        sortable: true,
        minWidth: 200,
        width: 200,
        lockPinned: true,
      },
      {
        headerName: 'Plan',
        field: 'telcoplanname',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        sortable: true,
        width: 300,
        minWidth: 300,
      },
      {
        headerName: 'Móvil',
        field: 'simmovil',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        sortable: true,
        minWidth: 200,
        width: 200,
        lockPinned: true,
      },
      {
        headerName: 'Estado',
        field: 'configvalor',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        sortable: true,
        width: 200,
        minWidth: 200,
        lockPinned: true,
      },
    ],
    //rowModelType: 'serverSide',
    serverSideDatasource: this.serverSide,
    rowSelection: 'multiple',
    columnTypes: {
      fecha: {
        sortable: true,
        resizable: true,
        filter: false,
      },
    },
    onGridReady: this.handleGridReady,
    onModelUpdated: this.onModelUpdated,
    onSelectionChanged: this.onSelectionChanged,
    processCellForClipboard: ({ value }) => {
      return value instanceof moment
        ? this.formatFecha(value as moment.Moment)
        : value;
    },
    onGridSizeChanged: event => {
      event.api.sizeColumnsToFit();
    },
  };

  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }

  created() {
    this.initialize();
  }

  initialize() {
    actionsEvent.$on('actionsEvent', (data: any) => {
      if (this.funcionalidad === Funcionalidades.TablaSolicitudBajaSimTarjeta) {
        if (data.action === Accion.Eliminar) {
          let item: any = null;
          this.gridApi.forEachNode((rowNode: RowNode) => {
            if (data.simserienumero == rowNode.data.simserienumero) {
              item = rowNode.data;
              return true;
            }
          });
          if (item !== null) {
            let indexDelete = this.dataSelected.indexOf(
              data.cellRendererParams.data
            );
            this.dataSelected.splice(indexDelete, 1);
            this.gridApi.setRowData(this.dataSelected);
            this.gridApi.setDomLayout('autoHeight');
            this.$emit('selected', this.dataSelected);
            this.$emit('esCargaArchivo', this.esCargaDeArchivo);
            this.idsSims = this.dataSelected.map((e: any) => {
              return e.simserienumero;
            });
          }
        }
      }
    });
  }
  cargar() {}
  prepare_file_upload() {
    const input = document.getElementById(
      'archivoExcel'
    ) as HTMLInputElement | null;
    if (input != null && input.files) {
      this.fileName = input.files[0].name;
      const file = input.files[0];
      const reader = new FileReader();
      let rawImg;
      reader.onloadend = () => {
        rawImg = reader.result;
        this.archivoB64 = rawImg;
      };
      reader.readAsDataURL(file);
      readXlsFile(input.files[0])
        .then((rows: any) => {
          let datos: any = [...rows];
          if (datos.length == 0) {
            this.$snotify.warning(
              'Se espera que la primera columna tenga el título "SIM Numero"'
            );
            this.errorArchivo = true;
            return;
          }
          let firtsRow: any = datos[0] || '';
          if (firtsRow[0] != 'SIM Numero') {
            this.$snotify.warning(
              'Se espera que la primera columna tenga el título "SIM Numero"'
            );
            this.errorArchivo = true;
            return;
          }
          if (datos[0][0] != 'SIM Numero') {
            this.$snotify.warning(
              'Las columnas no coinciden con el formato esperado. Por favor, descargue la plantilla y complete los datos.'
            );
            this.errorArchivo = true;
            return;
          }
          let hasError = false;
          this.itemsDelExcel = datos.map((item: any, index: number) => {
            return {
              simserienumero: item[0].toString() || '',
            };
          });
          if (hasError) {
            this.errorArchivo = true;
            this.itemsDelExcel = [];
            this.errorArchivoModal = true;
            this.esCargaDeArchivo = false;
          } else {
            // Filtrar los elementos nulos (en caso de que haya habido errores de validación)
            this.itemsDelExcel = this.itemsDelExcel.filter(
              item => item !== null
            );
            this.itemsDelExcel.shift();
            this.errorArchivo = false;
            this.errorArchivoModal = false;
            this.esCargaDeArchivo = true;

            this.gridApi.setRowData(this.itemsDelExcel);
            this.gridApi.setDomLayout('autoHeight');
            this.idsSims = this.itemsDelExcel.map((e: any) => {
              return e.simserienumero;
            });
            this.dataSelected.push(...this.itemsDelExcel);
            this.$emit('selected', this.dataSelected);
            this.$emit('esCargaArchivo', this.esCargaDeArchivo);
          }
        })
        .catch((e: any) => {
          console.log(e);
          this.itemsDelExcel = [];
          this.errorMessage = `Ocurrió un error al leer el archivo: ${e.message}<br>`;
          this.errorArchivo = true;
          this.errorArchivoModal = true;
        });
    }
  }
  descargarPlantilla(tipo: any) {
    this.loadingService.showLoading(undefined, 'descargarPlantilla');
    let headers = {};
    headers = {
      header: ['SIM Numero'],
    };
    let ws: any = null;
    let name: string = '';
    ws = utils.json_to_sheet([], headers);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Plantilla');
    writeFileXLSX(wb, `Plantilla_Carga_SIM_Solicitud_Baja.xlsx`);
    this.$snotify.success('Plantilla Excel descargada con éxito', 3000);
    this.loadingService.hideLoading('descargarPlantilla');
  }
  quitarRegistro() {
    let input = document.getElementById(
      'archivoExcel'
    ) as HTMLInputElement | null;
    if (input) {
      input.value = ''; // Restablecer el valor del input
    }
    this.itemsDelExcel = [];
    this.archivoB64 = '';
    this.fileName = '';
    this.errorArchivoModal = false;
    this.errorMessage = '';
    this.errorArchivo = true;
    this.esCargaDeArchivo = false;

    this.gridApi.setRowData(this.itemsDelExcel);
    this.gridApi.setDomLayout('autoHeight');
    this.$emit('selected', this.itemsDelExcel);
    this.$emit('esCargaArchivo', this.esCargaDeArchivo);
    this.idsSims = this.itemsDelExcel.map((e: any) => {
      return e.simserienumero;
    });
  }
  click() {}
}
